import { Paper } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import Image from "../../Image";
import { RootStateType } from "../../../store/reducers";
import { useSelector } from "react-redux";

const NEW_NCT_TYPES = [
  {
    path: "/new-transaction/nct-type/digital/change-email",
    isPhygitalPath: "/new-transaction/nct-type/phygital/change-email",
    name: "Change/Update Email Address",
    isPhygitial: true,
    digital: "Digital mode",
    phygital: "Phygital mode",
    isNew: false,
  },
  {
    path: "/new-transaction/nct-type/digital/updateNominee",
    name: "Update Nominee Details",
    isPhygitial: false,
    digital: "Digital mode",
    isNew: false,
  },
  {
    path: "/new-transaction/nct-type/digital/change-mobile",
    isPhygitalPath: "/new-transaction/nct-type/phygital/change-mobile",
    name: "Change Registered Mobile Number ",
    isPhygitial: true,
    digital: "Digital mode",
    phygital: "Phygital mode",
    isNew: false,
  },
  {
    path: "/new-transaction/nct-type/digital/facta-declaration",
    name: "Fatca Declaration",
    isPhygitial: false,
    digital: "Digital mode",
    isNew: false,
  },
  {
    path: "/new-transaction/nct-type/digital/change-idcw",
    name: "Change of IDCW",
    isPhygitial: false,
    digital: "Digital mode",
    isNew: false,
  },
  {
    path: "/new-transaction/nct-type/digital/update-ifsc",
    name: "Update IFSC",
    isPhygitial: false,
    digital: "Digital mode",
    isNew: true,
  },
  // {
  //   path: "/new-transaction/nct-type/digital/consolidation-folios",
  //   name: "Consolidation of Folios",
  //   isPhygitial: false,
  //   digital: "Digital mode"
  // },

  // {
  //   path: "/new-transaction/nct-type/digital/correction-folios",
  //   name: "Correction of Folios",
  //   isPhygitial: false,
  //   digital: "Digital mode",
  // },
  {
    path: "/new-transaction/nct-type/digital/change-bank",
    name: "Change of Bank",
    isPhygitial: false,
    digital: "Digital mode",
    isNew: true,
  },
  {
    path: "/new-transaction/nct-type/digital/bank-mandate",
    name: "Multiple Bank Mandate Registration",
    isPhygitial: false,
    digital: "Digital mode",
    isNew: true,
  },
];

export default function NctTypes() {
  const history = useHistory();

  const NctTypeMap = NEW_NCT_TYPES;

  return (
    <div className="container-margin-tranaction">
      <div
        className="transaction-type-title"
        style={{
          margin: "50px 20px 10px ",
        }}
      >
        Select Transaction Type
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", paddingBottom: 20 }}>
        {NctTypeMap.map(
          (
            { name, path, isPhygitial, phygital, digital, isPhygitalPath },
            i
          ) => (
            <NctTypeCard
              onClick={(e: any, isPhygitial: boolean) => {
                history.push(isPhygitial ? isPhygitalPath : path, {
                  isPhygitial: isPhygitial,
                });
              }}
              name={name}
              isPhygitial={isPhygitial}
              phygital={phygital}
              digital={digital}
              key={i}
            />
          )
        )}
      </div>
    </div>
  );
}

function NctTypeCard({
  onClick,
  name,
  isPhygitial,
  phygital,
  digital,
}: {
  onClick: any;
  name: string;
  isPhygitial: boolean;
  phygital: string;
  digital: string;
}) {
  const commonStyle = {
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    fontSize: 13,
    color: "black",
    fontFamily: "OpenSans-Regular",
    flexBasis: 0,
    padding: "15px 0px",
    cursor: "pointer",
    // boxShadow: "-1px 1px 3px 1px lavender",
    //padding: "15px 0px 0px 0px",
    // borderRadius: 8,
  };
  return (
    <div className="transaction-typemain">
      <Paper
        className="transaction-type-cards-paper"
        style={{
          boxShadow: "-1px 1px 3px 1px lavender",
          padding: "15px 0px 0px 0px",
          borderRadius: 8,
        }}
        // onClick={onClick}
      >
        <div className="otp">
          <Image src="/images/nct_icon.svg" style={{ height: 80 }} alt="" />
        </div>
        <div
          className="transaction-type-cards-name"
          style={{
            color: "#007AC8",
          }}
        >
          {name}
        </div>

        <div
          style={{
            display: "flex",
            boxShadow: "1px -2px 2px -1px lavender",
          }}
        >
          <div
            style={{ ...commonStyle, boxShadow: "1px 0px 0px 0px lavender" }}
            onClick={(e) => onClick(e, false)}
          >
            {digital}
            <Image
              src={"/images/right-arrow-purple.svg"}
              style={{ height: 18, marginLeft: "2%", marginTop: "0.3%" }}
              alt="right_arrow"
            />
          </div>
          {isPhygitial && (
            <div
              style={{ ...commonStyle, boxShadow: "0px 0px 0px 1px lavender" }}
              onClick={(e) => onClick(e, true)}
            >
              {phygital}
              <Image
                src={"/images/right-arrow-purple.svg"}
                style={{ height: 20, marginLeft: "2%", marginTop: "0.3%" }}
                alt="right_arrow"
              />
            </div>
          )}
        </div>
      </Paper>
    </div>
  );
}
